import React from 'react';
import AdminSiteImageField from './AdminSiteImageField';
import { CopyCard, CopyField, setPageCopySection } from './adminSiteCopyFields';

export default function AdminSiteBrandFields({ form, setField, sessionToken, onPersistBrand }) {
  const brand = form.page_copy?.brand || {};
  const footer = form.page_copy?.footer || {};

  const setBrand = (patch) => setPageCopySection(form, setField, 'brand', patch);
  const setFooter = (patch) => setPageCopySection(form, setField, 'footer', patch);

  return (
    <>
      <CopyCard title="Brand identity" subtitle="Logo and name shown in header, footer, and page eyebrows">
        <CopyField
          id="brand-name"
          label="Brand / store name"
          value={brand.name || ''}
          onChange={(v) => setBrand({ name: v })}
          hint="Used in navigation, copyright, hero eyebrows, and SEO title suffixes."
        />
        <AdminSiteImageField
          id="brand-logo"
          label="Logo"
          value={brand.logo_url || '/saloni-logo.png'}
          onChange={(v) => setBrand({ logo_url: v })}
          sessionToken={sessionToken}
          aspect="1 / 1"
          onPersist={
            onPersistBrand
              ? async (path) => {
                  const pageCopy = form.page_copy || {};
                  const next = {
                    page_copy: {
                      ...pageCopy,
                      brand: { ...brand, logo_url: path },
                    },
                  };
                  setBrand({ logo_url: path });
                  const ok = await onPersistBrand(next);
                  return ok;
                }
              : undefined
          }
          hint="Square or circular logo works best. Default: /saloni-logo.png in public folder."
        />
      </CopyCard>

      <CopyCard title="Footer chrome" subtitle="Section headings and copyright line">
        <CopyField
          id="footer-explore"
          label="Explore column heading"
          value={footer.explore_heading || ''}
          onChange={(v) => setFooter({ explore_heading: v })}
        />
        <CopyField
          id="footer-connect"
          label="Connect column heading"
          value={footer.connect_heading || ''}
          onChange={(v) => setFooter({ connect_heading: v })}
        />
        <CopyField
          id="footer-shipping-label"
          label="Shipping link label"
          value={footer.shipping_link_label || ''}
          onChange={(v) => setFooter({ shipping_link_label: v })}
        />
        <CopyField
          id="footer-copyright"
          label="Copyright suffix"
          value={footer.copyright_suffix || ''}
          onChange={(v) => setFooter({ copyright_suffix: v })}
          hint='Shown as "© {year} {brand name}. {suffix}"'
        />
      </CopyCard>
    </>
  );
}
